/**
 * Lightweight analytics tracking — fire-and-forget via raw fetch().
 * Uses NO OpenAPI client (works on public pages without auth context).
 */

import { API_URL, API_PATH } from "@/api/apiClient";

const TRACKING_ENDPOINT = `${API_URL}${API_PATH}/analytics/track`;

// Persistent session ID per browser tab
function getSessionId(): string {
  let sid = sessionStorage.getItem("analytics_session_id");
  if (!sid) {
    sid = crypto.randomUUID();
    sessionStorage.setItem("analytics_session_id", sid);
  }
  return sid;
}

/**
 * Track an analytics event. Non-blocking — never throws, never awaits.
 */
export function trackEvent(
  eventType: string,
  entityType: string,
  entityId: string,
  projectId: string,
  properties?: Record<string, unknown>,
): void {
  const body = {
    event_type: eventType,
    entity_type: entityType,
    entity_id: entityId,
    project_id: projectId,
    properties: properties ?? null,
    session_id: getSessionId(),
  };

  fetch(TRACKING_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => {});
}
